/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";
import { useRefinementList } from "react-instantsearch-hooks-web";
import { useBoatQuery } from "../utils/useBoatQuery";
import { SearchBox } from "./SearchBox";

export const FilterMenu = (props) => {
  const { filterByAttribute } = useBoatQuery(props.attribute);
  const {
    items,
    refine,
    searchForItems,
    canToggleShowMore,
    isShowingMore,
    toggleShowMore,
  } = useRefinementList(props);

  console.log(items);

  const filteredItems = useMemo(
    () => filterByAttribute(props.attribute, items),
    [props.attribute, items, filterByAttribute]
  );

  return (
    <div>
      {props.searchable && (
        <SearchBox
          onChange={searchForItems}
          searchablePlaceholder={props.searchablePlaceholder}
        />
      )}
      {filteredItems.map((item) => (
        <ul key={item.value} className="ais-RefinementList-list">
          <li className="ais-RefinementList-item">
            <label className="ais-RefinementList-label">
              <input
                onChange={() => refine(item.value)}
                className="ais-RefinementList-checkbox"
                type="checkbox"
                value={item.value}
                checked={item.isRefined}
              />
              <span className="ais-RefinementList-labelText">{item.label}</span>
              <span className="ais-RefinementList-count">{item.count}</span>
            </label>
          </li>
        </ul>
      ))}
      {canToggleShowMore && (
        <button
          onClick={toggleShowMore}
          className="ais-RefinementList-showMore"
        >
          {isShowingMore ? "Show Less" : "Show more"}
        </button>
      )}
    </div>
  );
};
